import { render, staticRenderFns } from "./full-screen-loader.vue?vue&type=template&id=0ece7acd"
import script from "./full-screen-loader.vue?vue&type=script&lang=js"
export * from "./full-screen-loader.vue?vue&type=script&lang=js"
import style0 from "./full-screen-loader.vue?vue&type=style&index=0&id=0ece7acd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports